import type { FC, ReactNode } from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

/** Пара «подпись: значение» внутри сетки GRID_SX (./infoGrid). */
export const InfoItem: FC<{ label: string; children: ReactNode }> = ({
  label,
  children,
}) => (
  <Stack>
    <Typography variant="subtitle2" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body1" component="div">
      {children}
    </Typography>
  </Stack>
);
